'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientFactory = require('./client');
var ManagerFactory = require('./manager');
var StorageFactory = require('./storage');

var FullProducerFactory = require('./producer');
var PartialProducerFactory = require('./producer/browser/Partial');

var OfflineProducerFactory = require('./producer/offline');

var MetricsFactory = require('./metrics');

var SettingsFactory = require('./utils/settings');

var ReadinessGateFacade = require('./readiness');

var Context = require('./utils/context');

var keyParser = require('./utils/key/parser');
var Logger = require('./utils/logger');
var log = Logger('splitio');
var tracker = require('./utils/timeTracker');

// cache instances created
var instances = {};

//
// Create SDK instance based on the provided configurations
//
function SplitFactory(context, gateFactory, readyTrackers, mainClientMetricCollectors) {
  var sharedInstance = !!mainClientMetricCollectors;
  var settings = context.get(context.constants.SETTINGS);
  var storage = context.get(context.constants.STORAGE);
  var readiness = gateFactory(settings.startup.readyTimeout);

  context.put(context.constants.READINESS, readiness);

  // We are only interested in exposable EventEmitter
  var gate = readiness.gate,
      splits = readiness.splits,
      segments = readiness.segments;

  // Events name

  var SDK_READY = gate.SDK_READY,
      SDK_UPDATE = gate.SDK_UPDATE,
      SDK_READY_TIMED_OUT = gate.SDK_READY_TIMED_OUT;


  var metrics = sharedInstance ? undefined : MetricsFactory(context); // Shared instances use parent metrics collectors
  var producer = void 0;

  switch (settings.mode) {
    case 'localhost':
      producer = sharedInstance ? undefined : OfflineProducerFactory(context);
      break;
    case 'producer':
    case 'standalone':
      {
        context.put(context.constants.COLLECTORS, metrics && metrics.collectors);
        // We don't fully instantiate producer if we are creating a shared instance.
        producer = sharedInstance ? PartialProducerFactory(context) : FullProducerFactory(context);
        break;
      }
    case 'consumer':
      break;
  }

  if (readyTrackers && !sharedInstance) {
    // Only track ready events for non-shared clients
    var sdkReadyTracker = readyTrackers.sdkReadyTracker,
        splitsReadyTracker = readyTrackers.splitsReadyTracker,
        segmentsReadyTracker = readyTrackers.segmentsReadyTracker;

    // Defered setup of collectors for this task, as it is the only ready latency we store on BE.

    sdkReadyTracker.setCollectorForTask(metrics.collectors);

    gate.on(SDK_READY, sdkReadyTracker);
    splits.on(splits.SDK_SPLITS_ARRIVED, splitsReadyTracker);
    segments.on(segments.SDK_SEGMENTS_ARRIVED, segmentsReadyTracker);
  }

  // Start background jobs tasks
  producer && producer.start();
  metrics && metrics.start();

  // Ready promise
  var readyFlag = sharedInstance ? _promise2.default.resolve() : new _promise2.default(function (resolve, reject) {
    gate.on(SDK_READY, resolve);
    gate.on(SDK_READY_TIMED_OUT, reject);
  });

  // If no collectors are stored we are on a shared instance, save main one.
  context.put(context.constants.COLLECTORS, mainClientMetricCollectors);

  var api = (0, _assign2.default)(
  // Proto linkage of the EventEmitter to prevent any change
  (0, _create2.default)(gate),
  // GetTreatment/s
  ClientFactory(context),
  // Utilities
  {
    // Ready promise
    ready: function ready() {
      return readyFlag;
    },


    // Events contants
    Event: {
      SDK_READY: SDK_READY,
      SDK_UPDATE: SDK_UPDATE,
      SDK_READY_TIMED_OUT: SDK_READY_TIMED_OUT
    },

    // Destroy instance
    destroy: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Stop background jobs
                producer && producer.stop();
                metrics && metrics.stop();

                // Send impressions if required
                _context.next = 4;
                return metrics;

              case 4:
                _context.t0 = _context.sent;

                if (!_context.t0) {
                  _context.next = 7;
                  break;
                }

                metrics.flush();

              case 7:

                // Cleanup event listeners
                readiness.destroy();

                // Cleanup storage
                storage.destroy && storage.destroy();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function destroy() {
        return _ref.apply(this, arguments);
      }

      return destroy;
    }()
  });

  return {
    api: api,
    metricCollectors: metrics && metrics.collectors
  };
}

function SplitFacade(config) {
  // Tracking times. We need to do it here because we need the storage created.
  var readyLatencyTrackers = {
    splitsReadyTracker: tracker.start(tracker.TaskNames.SPLITS_READY),
    segmentsReadyTracker: tracker.start(tracker.TaskNames.SEGMENTS_READY),
    sdkReadyTracker: tracker.start(tracker.TaskNames.SDK_READY)
  };
  var context = new Context();
  var settings = SettingsFactory(config);
  var storage = StorageFactory(settings);
  var gateFactory = ReadinessGateFacade();

  context.put(context.constants.SETTINGS, settings);
  context.put(context.constants.STORAGE, storage);

  var _SplitFactory = SplitFactory(context, gateFactory, readyLatencyTrackers),
      defaultInstance = _SplitFactory.api,
      mainClientMetricCollectors = _SplitFactory.metricCollectors;

  log.info('New Split SDK instance created.');

  return {
    // Split evaluation engine
    client: function client(key) {
      if (!key) {
        log.debug('Retrieving default SDK client.');
        return defaultInstance;
      }

      if (typeof storage.shared != 'function') {
        throw 'Shared Client not supported by the storage mechanism. Create isolated instances instead.';
      }

      var parsedkey = keyParser(key);
      var instanceId = parsedkey.matchingKey + '-' + parsedkey.bucketingKey;

      if (!instances[instanceId]) {
        var sharedSettings = settings.overrideKey(key);
        var sharedContext = new Context();
        sharedContext.put(context.constants.SETTINGS, sharedSettings);
        sharedContext.put(context.constants.STORAGE, storage.shared(sharedSettings));
        instances[instanceId] = SplitFactory(sharedContext, gateFactory, false, mainClientMetricCollectors).api;
        log.info('New shared client instance created.');
      } else {
        log.debug('Retrieving existing SDK client.');
      }

      return instances[instanceId];
    },


    // Manager API to explore available information
    manager: function manager() {
      log.info('New manager instance created.');
      return ManagerFactory(storage.splits);
    },


    // Logger wrapper API
    Logger: Logger.API,

    // Expose SDK settings
    settings: settings
  };
}

module.exports = SplitFacade;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/index.js
// module id = 468
// module chunks = 11